import React, { useState } from 'react'
import Chart from 'react-apexcharts'
import ApexCharts from 'apexcharts'
import { IDadosGraficosPesquisaModel } from '../helpers/AnaliseResultadoHelper'
import { ModalGraficoDispersao } from './ModalGraficoDispersao'

type Props = {
  dadosGraficosPesquisa: IDadosGraficosPesquisaModel | undefined
}

const GraficoDispersao = ({ dadosGraficosPesquisa }: Props) => {
  const [showModal, setShowModal] = useState<boolean>(false)
  const [dimensaoIndex, setDimensaoIndex] = useState<number | undefined>(undefined)
  const [dispersaoIndex, setDispersaoIndex] = useState<number | undefined>(undefined)
  const [fillColor, setFillColor] = useState<string | undefined>(undefined)
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const stackType: 'normal' | '100%' = '100%'

  const downloadChart = (format: 'png' | 'jpeg') => {
    ApexCharts.exec('grafico-dispersao', 'dataURI')
      .then((res: { imgURI: string }) => {
        const link = document.createElement('a')
        link.href = res.imgURI
        link.download = `grafico_dispersao.${format}`
        link.click()
      })
      .catch((e: unknown) => {
        console.error('Erro ao gerar imagem:', e)
      })
  }

  const options = {
    colors: dadosGraficosPesquisa?.GraficoDispersao.Colors ?? [],
    series: dadosGraficosPesquisa?.GraficoDispersao.Series ?? [],
    chart: {
      id: 'grafico-dispersao',
      stacked: true,
      stackType: stackType,
      toolbar: { show: false },
      events: {
        click: function (
          event: React.ChangeEvent<HTMLInputElement>,
          chartContext: any,
          config: any
        ) {
          const valueJ = event.target.attributes.getNamedItem('j')?.value
          const valueI = event.target.attributes.getNamedItem('index')?.value
          const fColor = event.target.attributes.getNamedItem('fill')?.value
          if (valueJ !== undefined && valueI !== undefined && fColor !== undefined) {
            setDimensaoIndex(parseInt(valueJ))
            setDispersaoIndex(parseInt(valueI))
            setFillColor(fColor)
            setShowModal(true)
          } else {
            setDimensaoIndex(undefined)
            setDispersaoIndex(undefined)
            setFillColor(undefined)
          }
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: dadosGraficosPesquisa?.GraficoDispersao.Categories ?? []
    },
    fill: {
      opacity: 1
    },
    legend: {
      offsetX: 40
    }
  }

  return (
    <>
      <ModalGraficoDispersao
        showModal={showModal}
        setShowModal={setShowModal}
        dimensaoIndex={dimensaoIndex}
        dispersaoIndex={dispersaoIndex}
        fillColor={fillColor}
        dadosGraficosPesquisa={dadosGraficosPesquisa}
      />

      <div className={`card mb-10 ${dadosGraficosPesquisa ? '' : 'd-none'}`}>
        <div className='card-header justify-content-between'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Dispersão</h3>
          </div>

          {/* Botão ☰ */}
          <div className='card-toolbar'>
            <div className='dropdown'>
              <button
                className='btn btn-light btn-sm dropdown-toggle'
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                ☰
              </button>
              <div
                className={`dropdown-menu dropdown-menu-end ${dropdownOpen ? 'show' : ''}`}
                style={{ minWidth: '160px' }}
              >
                <button className='dropdown-item' onClick={() => downloadChart('png')}>
                  Baixar PNG
                </button>
                <button className='dropdown-item' onClick={() => downloadChart('jpeg')}>
                  Baixar JPEG
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className='card-body'>
          <div className='row justify-content-center my-10 mx-8'>
            <Chart options={options} series={options.series} type='bar' height={'400px'} />
          </div>
        </div>
      </div>
    </>
  )
}

export { GraficoDispersao }
